import { ERoles } from '@/auth/constants';
import { BackkdropLoader } from '@/components/backdroploader';
import { PermWrapper } from '@/components/permwrapper';
import { Unauthorized } from '@/components/unauthorized';
import React from 'react';
import { Suspense } from 'react';
import { Route } from 'react-router-dom';

const EmailTemplateReplication = React.lazy(
	() => import('@/views/templates/email/replication/main')
);

export const TemplateRoutes = (
	<>
		<Route
			path='/templates/email/replication'
			element={
				<Suspense fallback={<BackkdropLoader />}>
					<PermWrapper
						allowedRoles={[
							ERoles.ADMIN,
							ERoles.TEMPLATE_ADMIN,
							ERoles.TEMPLATE_MANAGER
						]}
						fallback={<Unauthorized />}>
						<EmailTemplateReplication />
					</PermWrapper>
				</Suspense>
			}
		/>
	</>
);
